module.exports = __webpack_public_path__ + "static/media/Mask2.c1decc17.jpg";